export default __webpack_public_path__ + "static/media/280.ed19a903.png";